import { createSlice } from "@reduxjs/toolkit";

import {
  fetchDocumentStyleTemplates,
  removeStyleTemplateById,
} from "../actions/addInSettings";

const INITIAL_STATE = {
  styleTemplates: [],
};

export const addInSettingsSlice = createSlice({
  name: "addInSettings",
  initialState: INITIAL_STATE,
  reducers: {
    reset: () => INITIAL_STATE,
  },
  extraReducers: (builder) => {
    builder.addAsyncThunk(fetchDocumentStyleTemplates, {
      fulfilled: (state, { payload = [] }) => {
        state.styleTemplates = payload;
      },
      rejected: () => {},
    });
    builder.addAsyncThunk(removeStyleTemplateById, {
      fulfilled: (state, { payload }) => {
        if (!payload) return state;

        const { styleTemplates } = state;
        state.styleTemplates = styleTemplates.filter(
          ({ id }) => id !== payload
        );
      },
    });
  },
});

export const { reset } = addInSettingsSlice.actions;

export default addInSettingsSlice.reducer;
